enum SegmentationType {
  STATIC = 1,
  DYNAMIC = 2,
  PLAYERS = 3,
  RULES_TRIGGER = 4,
  RULES_SEGMENT = 5,
}

export default SegmentationType
